import { render, staticRenderFns } from "./LimitRecalculation.vue?vue&type=template&id=41edb2ce&scoped=true&"
import script from "./LimitRecalculation.vue?vue&type=script&lang=js&"
export * from "./LimitRecalculation.vue?vue&type=script&lang=js&"
import style0 from "./LimitRecalculation.vue?vue&type=style&index=0&id=41edb2ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41edb2ce",
  null
  
)

export default component.exports